export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-01.3e388414.jpg";